<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12ZM7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H14.584L13.2929 14.2929L13.2097 14.3871C12.9047 14.7794 12.9324 15.3466 13.2929 15.7071C13.6834 16.0976 14.3166 16.0976 14.7071 15.7071L17.7071 12.7071L17.7803 12.6254L17.854 12.5207L17.9063 12.4232L17.9503 12.3121L17.9798 12.2007L17.9972 12.0752L18 12L17.9931 11.8819L17.9642 11.734L17.9288 11.6287L17.8753 11.5159L17.8037 11.4047L17.7485 11.3369L17.7071 11.2929L14.7071 8.29289L14.6129 8.2097C14.2206 7.90468 13.6534 7.93241 13.2929 8.29289L13.2097 8.3871L13.1404 8.4886C12.9116 8.87249 12.9625 9.37666 13.2929 9.70711L14.586 11H7Z"
    fill="currentColor"
  />
</svg>
